<template>
  <div>
    <template v-if="!isMobile()">
      <div class="colu colu-md-6 flex-colu mb-3">
        <div class="colu-12 for-label">
          {{ $t("Bao.deposit_currency") }}
        </div>
        <div class="ch-crypto-form">
          <div class="form-input-n2">
            <div class="crypto-select-frame">
              <div class="lang-select">
                <button class="btn-select" @click="toggleDropdown">
                  <li v-if="selectedCoin">
                    <img :src="$getThemeImagePath(`crypto-${selectedCoin.symbol.toLowerCase()}.svg`)" alt="">
                    <span>{{ selectedCoin.symbol }}</span>
                  </li>
                </button>
                <div class="b" :class="{ active: isOpen }">
                  <ul class="crypto-list">
                    <li v-for="coin in coinList" :key="coin.coinId" @click="selectCrypto(coin)">
                      <img :src="$getThemeImagePath(`crypto-${coin.symbol.toLowerCase()}.svg`)">
                      <span>{{ coin.symbol }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                v-if="selectedPayment && selectedPayment.payment_fee && selectedPayment.payment_fee.member !== 0"
                class="text-align-R"
              >
                {{ $t('Bao.payment_fee') }} {{ selectedPayment.payment_fee.member }} %
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="colu colu-md-6 flex-colu">
        <label class="colu-12 for-label" for="ネットワークを選択">{{ $t("Bao.deposit_chain") }}</label>
        <select
          id="ネットワークを選択"
          v-model="selectedChain"
          class="for-select inpType icon-select fs-14-w-700"
        >
          <option v-for="(chainObj, index) in chainList" :key="index" :value="chainObj">
            {{ getChainDisplayName(chainObj.chain) }}
          </option>
        </select>
      </div>

      <div class="colu colu-xl-6 colu-sm-12 flex-colu">
        <label class="colu-12 for-label" for="入金アドレス">{{ $t("Bao.deposit_address") }}</label>
        <div class="colu-12 inp-relative">
          <input
            id="入金アドレス"
            class="for-input inpType fs-14-w-700"
            type="text"
            :placeholder="deposit_address"
            disabled
          >
          <button class="btn btn-keyChainCopy" @click.prevent="copyText(deposit_address)" />
        </div>
        <template v-if="memo">
          <label class="colu-12 for-label colu-mr-t" for="Destination Tag">
            {{ $t("Bao.destination_tag") }}
          </label>
          <div class="colu-12 inp-relative">
            <input
              id="Destination Tag"
              v-model="memo"
              class="for-input inpType fs-14-w-700"
              type="text"
              disabled
            >
            <button class="btn btn-keyChainCopy" @click.prevent="copyText(memo, 'memo')" />
          </div>
          <div class="input-feedback remarks">
            <div class="row-frame">
              <div class="colu-auto icon-pr-1">
                <i class="icon-alert">
                  <img :src="$getThemeImagePath('icon_alert.png')" alt="">
                </i>
              </div>
              <div class="colu-11 fs-14px fs-remarks-box">
                {{ $t("Bao.destination_tag_describe") }}
              </div>
            </div>
          </div>
        </template>
      </div>

      <div v-if="deposit_address" class="colu colu-xl-6 colu-sm-12">
        <div class="colu colu-12 depositAddressQR">
          <div class="authenQR addressQR">
            <qrcode-vue :value="deposit_address" :size="74" />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- 入金通貨 -->
      <div class="crypto-select-frame">
        <div class="colu-12 for-label">
          {{ $t("Bao.deposit_currency") }}
        </div>
        <div class="lang-select">
          <button class="btn-select" @click="toggleDropdown">
            <li v-if="selectedCoin">
              <img :src="$getThemeImagePath(`crypto-${selectedCoin.symbol.toLowerCase()}.svg`)" class="w-6 h-6">
              <span>{{ selectedCoin.symbol }}</span>
            </li>
          </button>
          <div class="b" :class="{ active: isOpen }">
            <ul class="crypto-list">
              <li v-for="coin in coinList" :key="coin.coinId" @click="selectCrypto(coin)">
                <img :src="$getThemeImagePath(`crypto-${coin.symbol.toLowerCase()}.svg`)">
                <span>{{ coin.symbol }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div
          v-if="selectedPayment && selectedPayment.payment_fee && selectedPayment.payment_fee.member !== 0"
          class="input-feedback remarks text-align-R"
        >
          {{ $t('Bao.payment_fee') }} {{ selectedPayment.payment_fee.member }} %
        </div>
      </div>

      <!-- 其他欄位 -->
      <form class="dep-form-frame">
        <!-- ネットワークを選択 -->
        <div class="colu colu-12 flex-colu">
          <label class="colu-12 for-label" for="ネットワークを選択-mb">{{ $t("Bao.deposit_chain") }}</label>
          <select
            id="ネットワークを選択-mb"
            v-model="selectedChain"
            class="for-select inpType icon-select fs-14-w-700"
          >
            <option v-for="(chainObj, index) in chainList" :key="index" :value="chainObj">
              {{ getChainDisplayName(chainObj.chain) }}
            </option>
          </select>
        </div>

        <!-- 入金アドレス -->
        <div class="colu colu-12 flex-colu">
          <label class="colu-12 for-label" for="入金アドレス-mb">{{ $t("Bao.deposit_address") }}</label>
          <div class="inp-relative">
            <input
              id="入金アドレス-mb"
              class="for-input inpType fs-14-w-700"
              type="text"
              :placeholder="deposit_address"
              disabled
            >
            <button class="btn btn-keyChainCopy" @click.prevent="copyText(deposit_address)" />
          </div>
        </div>

        <!-- Destination Tag -->
        <div v-if="memo" class="colu colu-12 flex-colu">
          <label class="colu-12 for-label" for="Destination Tag-mb">
            {{ $t("Bao.destination_tag") }}
          </label>
          <div class="inp-relative">
            <input
              id="Destination Tag-mb"
              v-model="memo"
              class="for-input inpType fs-14-w-700"
              type="text"
              disabled
            >
            <button class="btn btn-keyChainCopy" @click.prevent="copyText(memo, 'memo')" />
          </div>
          <div class="input-feedback remarks">
            <div>
              <i class="icon-alert">
                <img :src="$getThemeImagePath('icon_alert.png')" alt="">
              </i>
              <span class="fs-14px fs-remarks-box">
                {{ $t("Bao.destination_tag_describe") }}
              </span>
            </div>
          </div>
        </div>

        <!-- QR Code -->
        <div v-if="deposit_address" class="colu colu-12">
          <div class="depositAddressQR">
            <div class="authenQR addressQR">
              <qrcode-vue :value="deposit_address" :size="100" />
            </div>
          </div>
        </div>
      </form>
    </template>
  </div>
</template>

<script>
import { detectMob, copyText } from '@/utils/tool'
import { getCoinlist, getDepositAddress } from '@/api/payment'
import qrcodeVue from 'qrcode.vue'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'CryptoDetail',
  components: {
    'qrcode-vue': qrcodeVue
  },
  mixins: [themeMixin],
  props: {
    selectedPayment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      coinList: [],
      chainList: [],
      selectedCoin: null,
      selectedChain: null,
      deposit_address: null,
      isUpdatingCoin: false,
      memo: null
    }
  },
  computed: {
    ...mapGetters(['app', 'brandInfo'])
  },
  watch: {
    selectedPayment: {
      handler(newPayment) {
        if (newPayment) {
          this.loadCoinList()
        }
      }
    },
    selectedCoin: {
      handler(newCoin) {
        this.isUpdatingCoin = true

        if (newCoin && newCoin.networks) {
          this.chainList = Object.values(newCoin.networks).map(network => ({
            chain: network.chain,
            minimumWithdrawAmount: network.minimumWithdrawAmount
          }))

          this.selectedChain = this.chainList[0] || null
        } else {
          this.chainList = []
          this.selectedChain = null
        }

        this.$nextTick(() => {
          this.fetchDepositAddress()
          this.isUpdatingCoin = false
        })
      },
      immediate: true
    },
    selectedChain: {
      handler(newChain) {
        if (!this.isUpdatingCoin && newChain && this.selectedCoin) {
          this.fetchDepositAddress()
        }
      },
      deep: true
    }
  },
  created() {
    this.loadCoinList()
  },
  methods: {
    getChainDisplayName(chain) {
      if (!chain) return ''
      if (!this.isTheme('theme_gold')) return chain

      const chainNameMap = {
        'BSC': 'BSC (BEP20)',
        'ETH': 'ETH (ERC20)',
        'TRX': 'TRX (TRC20)'
      }
      return chainNameMap[chain] || chain
    },
    isMobile() {
      return detectMob()
    },
    copyText(msg, text) {
      if (text === 'memo') {
        copyText(msg, this.memo)
      } else {
        copyText(msg, this.deposit_address)
      }
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    selectCrypto(coin) {
      this.selectedCoin = coin
      this.isOpen = false
    },
    loadCoinList() {
      getCoinlist().then((response) => {
        const allCoins = response.data.data

        // 把所有 wallet_types 組成一個扁平陣列
        const walletTypes = this.brandInfo.wallet_types
          .reduce((arr, item) => arr.concat(item.wallet_type), [])

        // 過濾出 symbol 有匹配到 wallet_types 的
        const matchedCoins = allCoins.filter(coin =>
          walletTypes.includes(coin.symbol)
        )

        this.coinList = matchedCoins

        const selectedWallet = this.app.selectedWallet
        if (!selectedWallet || Object.keys(selectedWallet).length === 0 ||
            selectedWallet.wallet_type === 'main' || selectedWallet.wallet_type === 'commission' || selectedWallet.wallet_type === 'bonus') {
          this.selectedCoin = this.coinList[0]
        } else {
          this.selectedCoin = this.coinList.find(coin => coin.symbol === selectedWallet.wallet_type)
        }
      }).catch((e) => {
        console.error(e)
      })
    },
    fetchDepositAddress() {
      if (!this.selectedCoin || !this.selectedChain) {
        return
      }

      this.deposit_address = null

      const params = {
        symbol: this.selectedCoin.symbol,
        chain: this.selectedChain.chain
      }

      getDepositAddress(params).then((response) => {
        this.deposit_address = response.data.data.content
        this.memo = response.data.data.memo
      }).catch((e) => {
        console.error(e)
      })
    }
  }
}
</script>
